<template>
  <div>
    <!-- 提报人信息 -->
    <div class="trade-order-block">
      <div class="block-title">提报人信息</div>
      <div class="block-content">
        <el-row class="content-row">
          <!-- 提报人 -->
          <el-col :span="3">提报人</el-col>
          <el-col :span="9">{{ tradeApplyInfoVO.applyClientName }}</el-col>
          <!-- 所属区域 -->
          <el-col :span="3">提报人电话</el-col>
          <el-col :span="9">{{ tradeApplyInfoVO.applyClientPhone }}</el-col>
        </el-row>
        <el-row class="content-row">
          <!-- 提报人 -->
          <el-col :span="3">所属BU</el-col>
          <el-col :span="9">{{ tradeApplyInfoVO.buName }}</el-col>

          <!-- 所属区域 -->
          <el-col :span="3">所属Region</el-col>
          <el-col :span="9">{{ tradeApplyInfoVO.regionName }}</el-col>
        </el-row>
        <el-row class="content-row" v-if="tradeApplyInfoVO.applyType == '03'">
          <!-- 提报人 -->
          <el-col :span="3">所属BU ISPTM</el-col>
          <el-col :span="9">{{ tradeApplyInfoVO.buIspTmName}}</el-col>
        </el-row>
      </div>
    </div>

    <!-- 门店基本信息 --除了批量化物料没有门店基本信息-->
    <div class="trade-order-block" v-show="tradeApplyOrderVO.applyType !== '02'">
      <div class="block-title">门店基本信息</div>
      <div class="block-content">
        <el-row class="content-row">
          <BaseCell :value="tradeApplyInfoVO.pocName" label="门店名称" />
          <BaseCell :value="tradeApplyInfoVO.pocCode" label="门店编码" />
        </el-row>
        <el-row class="content-row">
          <BaseCell :value="basePocInfo.channelName" label="渠道" />
          <BaseCell :value="basePocInfo.subChannelName" label="子渠道" />
        </el-row>
        <el-row class="content-row">
          <BaseCell :value="basePocInfo.businessChannelName" label="业务渠道" />
          <BaseCell :value="tradeApplyBaseVO.wccsId" label="WCCSID" v-if="basePocInfo.abiPocId"  />
          <BaseCell :value="basePocInfo.wccsId" label="WCCSID" v-else />
        </el-row>
        <el-row class="content-row">
          <BaseCell v-if="execTypeSub !== '108'" :value="basePocInfo.annualTotalSale" label="门店啤酒年销量" numberFormat valueUnit="箱" />
          <BaseCell :value="isPbo" label="是否ABI买店" />
        </el-row>
        <el-row class="content-row">
          <BaseCell v-if="execTypeSub !== '108'" :value="basePocInfo.annualAbiSale" label="ABI啤酒年销量" numberFormat valueUnit="箱" />
          <BaseCell :value="detailAddress" label="门店地址" />
        </el-row>
        <el-row class="content-row">
          <BaseCell v-if="execTypeSub !== '108'" :value="basePocInfo.annualBudSale" label="- ABI啤酒年销量" subCell numberFormat valueUnit="箱" />
        </el-row>
        <el-row class="content-row" v-if="execTypeSub !== '108'">
          <BaseCell :value="basePocInfo.annualAdvanceSale" label="- 哈啤/雪津啤酒年销量" subCell allCell numberFormat valueUnit="箱" />
        </el-row>
        <el-row class="content-row" v-if="execTypeSub !== '108'">
          <BaseCell :value="basePocInfo.annualPremiumSale" label="- 超高端啤酒年销量" subCell allCell numberFormat valueUnit="箱" />
        </el-row>
        <el-row class="content-row">
          <el-col :span="3">门店照片</el-col>
          <el-col :span="21" class="info-img">
            <div v-if="pocImageList.length">
              <div class="img-wrapper" v-for="img in pocImageList" :key="img.title">
                <el-image
                  :src="getImg(img.imageUri)"
                  :preview-src-list="getPreviewImageList(pocImageList)"
                  fit="cover"
                  class="img-wrapper__item"
                />
                <div class="img-wrapper-title">{{ img.title }}</div>
              </div>
            </div>
            <div v-else>暂无</div>
          </el-col>
        </el-row>
        <el-row class="content-row">
          <BaseCell :value="getImg(basePocInfo.bizLicensePhotoUri)" label="门店营业执照" isImg />
          <BaseCell :value="getImg(basePocInfo.dianpinImageUri)" label="大众点评/美团/饿了么截图" isImg />
        </el-row>

        <el-row class="content-row">
          <el-col :span="3">补充资料</el-col>
          <el-col :span="21" class="info-img">
            <div v-if="
              tradeApplyBaseVO.pocImageList &&
              tradeApplyBaseVO.pocImageList.length
            ">
              <div class="img-wrapper" v-for="(img,index) in tradeApplyBaseVO.pocImageList" :key="index">
                <el-image
                  :src="getImg(img.imageUri)"
                  :preview-src-list="getPreviewImageList(tradeApplyBaseVO.pocImageList)"
                  fit="cover"
                  class="img-wrapper__item"
                />
                <div class="img-wrapper-title">{{ img.imageName }}</div>
              </div>
            </div>
            <div v-else>暂无</div>
          </el-col>
        </el-row>
        <div class="block-content">
          <el-row class="content-row">
            <div id="content-map"></div>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { commonUtils } from '@/utils/common'
import BaseCell from '@/components/base-cell'
export default {
  name: 'poc-base-info',
  components: {
    BaseCell
  },
  props: {
    tradeApplyOrderVO: {},
    tradeApplyInfoVO: {},
    basePocInfo: {},
    tradeApplyBaseVO: {},
    tradeApplyExecVO: {}
  },
  data () {
    return {
      pocImageList: []
    }
  },
  computed: {
    tradeApplyBizVO () {
      return this.tradeApplyInfoVO.tradeApplyBizVO || {}
    },
    isPbo () {
      if (this.basePocInfo.isPboName === null) { return this.basePocInfo.isPboName }
      return this.basePocInfo.isPboName ? '是' : '否'
    },

    execTypeSub () {
      if (this.tradeApplyExecVO) {
        return this.tradeApplyExecVO?.execTypeSub
      }
      return ''
    },

    detailAddress () {
      const { provinceName, cityName, countyName, detailAddress } = this.basePocInfo
      return `${provinceName || ''}${cityName || ''}${countyName || ''}${detailAddress || ''}`
    },
  },
  created () { },
  methods: {
    initMap (info) {
      this.pocImageList = []
      // 售点照片
      if (this.basePocInfo.pocOutsidePhotoUri) {
        this.pocImageList.push({
          title: '门头照',
          imageUri: info.pocOutsidePhotoUri
        })
      }
      if (this.basePocInfo.pocExternalPhotoUri && this.execTypeSub !== '108') {
        this.pocImageList.push({
          title: '外部整体',
          imageUri: info.pocExternalPhotoUri
        })
      }
      if (this.basePocInfo.pocInsidePhotoUri && this.execTypeSub !== '108') {
        this.pocImageList.push({
          title: '内部整体',
          imageUri: info.pocInsidePhotoUri
        })
      }
      if (this.basePocInfo.pocStreetPhotoUri && this.execTypeSub !== '108') {
        this.pocImageList.push({
          title: '外部街区',
          imageUri: info.pocStreetPhotoUri
        })
      }

      const { locLatitude, locLongitude, pocName } = info
      if (!locLatitude || !locLongitude) return
      const map = new AMap.Map('content-map', {
        center: [locLongitude, locLatitude],
        zoom: 16
      })
      const position = new AMap.LngLat(locLongitude, locLatitude)
      const marker = new AMap.Marker({position, map})
      const handleMapClick = AMap.Event.addListener(map, 'click', () => {
        window.open(`https://uri.amap.com/marker?position=${locLongitude},${locLatitude}&name=${pocName}&src=尊享先锋订单平台`)
      })
    },

    getImg (uri) {
      if (!uri) return null
      return commonUtils.getImageUrl(uri)
    },

    getPreviewImageList (list) {
      if (list && list.length) {
        return list.map(item => {
          return this.getImg(item.imageUri)
        })
      }
      return []
    }
  }
}
</script>

<style lang="scss" scoped>
#content-map {
  width: 450px;
  height: 200px;
  border-radius: 8px;
  cursor: pointer;
}
</style>
